module.exports = __webpack_public_path__ + "static/eclipse1-55ea56e8853638c5fdf4e6b63ed9a49c.png";